import { useCallback, useState } from 'react';
import style from './index.module.scss';
import {
  CheckOutlined,
  CloseOutlined,
  CloudServerOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';

const MAX_IN_MB = 2;

type TDocCard = {
  icon: string;
  text: string;
  onBlob: (blob: Blob) => void;
  disabled?: boolean;
  uploaded?: boolean;
  rejected?: boolean;
};

export const DocCard = ({
  icon,
  text,
  onBlob,
  disabled,
  uploaded,
  rejected,
}: TDocCard) => {
  const [maxSize, setMaxSize] = useState(false);
  const [okFile, setOKFile] = useState(false);

  const onClick = useCallback(() => {
    if (disabled) return;

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.jpg, .png, .jpeg, .pdf';
    input.addEventListener('change', (event: any) => {
      setMaxSize(false);
      setOKFile(false);
      const file = event.target.files[0];

      const maxSizeInBytes = MAX_IN_MB * 1024 * 1024;

      if (file.size > maxSizeInBytes) {
        console.error('File size exceeds maximum limit.');
        setMaxSize(true);
        return;
      }

      const reader = new FileReader();
      reader.addEventListener('load', (event: any) => {
        const arrayBuffer = event.target.result;
        onBlob && onBlob(new Blob([arrayBuffer], { type: file.type }));
        setOKFile(true);
      });

      reader.readAsArrayBuffer(file);
    });
    input.click();
  }, [disabled, onBlob]);
  

  return (
    <div
      onClick={onClick}
      className={`${style.card} ${maxSize || rejected ? style.error : ''} ${
        okFile ? style.ok : ''
      } ${disabled ? style.disabled : ''}`}
    >
      {maxSize && <CloseOutlined className={style.iconError} />}
      {okFile && <CheckOutlined className={style.iconOk} />}
      {!okFile && !maxSize && uploaded && (
        <CloudServerOutlined className={style.iconUp} />
      )}
      <img src={icon} alt={text} />
      <p>{text}</p>
      {maxSize && (
        <p className={style.textError}>{`Tamaño máximo: ${MAX_IN_MB}mb`}</p>
      )}
    </div>
  );
};
